export default __webpack_public_path__ + "static/wlc-live-event-card-bg-1e730390.jpg";